module.exports = __webpack_public_path__ + "static/img/行驶.e531cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/叉车/行驶.png
// module id = bjf/
// module chunks = 76